import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-10">
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 sm:gap-8">
          {/* Left Column */}
          <div className="space-y-3 text-center sm:text-left">
            <Link to="/privacy" className="block text-gray-400 hover:text-white transition-colors text-sm">
              Privacy Policy
            </Link>
            <Link to="/terms" className="block text-gray-400 hover:text-white transition-colors text-sm">
              Terms & Conditions
            </Link>
            <Link to="/about" className="block text-gray-400 hover:text-white transition-colors text-sm">
              About
            </Link>
          </div>

          {/* Center - Social Icons */}
          <div className="col-span-2 sm:col-span-1 flex justify-center items-center order-first sm:order-none">
            <div className="flex space-x-4">
              <a
                href="https://instagram.com"
                aria-label="Instagram"
                target="_blank"
                rel="noreferrer"
                className="w-11 h-11 sm:w-12 sm:h-12 border-2 border-beige-500 rounded-lg flex items-center justify-center hover:bg-beige-500 hover:text-black transition-colors"
              >
                <Instagram className="w-5 h-5 sm:w-6 sm:h-6" />
              </a>
              <a
                href="https://facebook.com"
                aria-label="Facebook"
                target="_blank"
                rel="noreferrer"
                className="w-11 h-11 sm:w-12 sm:h-12 border-2 border-beige-500 rounded-lg flex items-center justify-center hover:bg-beige-500 hover:text-black transition-colors"
              >
                <Facebook className="w-5 h-5 sm:w-6 sm:h-6" />
              </a>
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-3 text-center sm:text-right">
            <Link to="/shipping" className="block text-gray-400 hover:text-white transition-colors text-sm">
              Shipping Info
            </Link>
            <Link to="/returns" className="block text-gray-400 hover:text-white transition-colors text-sm">
              Returns & Exchange
            </Link>
            <Link to="/contact" className="block text-gray-400 hover:text-white transition-colors text-sm">
              Contact
            </Link>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-6 sm:mt-8 pt-4 sm:pt-5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3">
            <p className="text-gray-400 text-xs sm:text-sm text-center md:text-left">
              © {new Date().getFullYear()} Glowy. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
              <Link to="/privacy" className="text-gray-400 hover:text-white text-xs sm:text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white text-xs sm:text-sm transition-colors">
                Terms of Service
              </Link>
              <Link to="/cookies" className="text-gray-400 hover:text-white text-xs sm:text-sm transition-colors">
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
